<template>
  <div class="create-notifications new-globals">
    <p v-if="error" class="error">
      {{ error.message }}
    </p>
    <div class="md-layout md-gutter">
      <div
        class="left-column md-layout-item"
      >
        <h2>New Notification</h2>
        <md-field>
          <label>Header</label>
          <md-input v-model="state.notification.title" maxlength="25" />
        </md-field>
        <md-field>
          <label>Body</label>
          <md-textarea v-model="state.notification.message" maxlength="500" />
        </md-field>
        <div class="notification-color-select">
          <label>Header Text Color</label>
          <div>
            <md-radio 
              v-for="c in notificationColors" 
              :key="c"
              v-model="state.notification.color"
              :style="{ 'background-color': c }"
              :value="c"
            />
          </div>
        </div>
        <div class="container">
          <md-field>
            <label>Go To Link</label>
            <md-input 
              :value="state.url"
              @input="setUrl"
            />
          </md-field>
          <label class="or">Or</label>
          <md-field>
            <label>Default Template</label>
            <md-select
              placeholder="Default Template"
              :value="state.caseId"
              @md-selected="setCaseId"
            >
              <md-option
                v-for="caseConf in cases"
                :key="caseConf.id"
                :value="caseConf.id"
              >
                {{ caseConf.name }}
              </md-option>
            </md-select>
          </md-field>
        </div>
      </div>
      <div
        class="right-column md-layout-item"
      >
        <notification-targets 
          :key="notificationTargetsKey"
          @add="(targets) => addTargets(targets)" 
        />
        <target-list
          class="target-list"
          :targets="state.notification.targets"
          @deleteTarget="deleteTarget"
        />
      </div>
    </div>
    <div class="actions">
      <md-button
        class="md-raised md-neutral"
        :disabled="sending"
        @click="resetNotification"
      >
        Clear
      </md-button>
      <md-button
        class="md-primary md-raised"
        :disabled="sending || !sendEnabled"
        @click="sendNotification"
      >
        {{ sending ? 'Sending' : 'Send' }}
      </md-button>
    </div>
        
    <md-dialog :md-active.sync="notifcationSentModalOpen" :md-fullscreen="false">
      <md-dialog-title>Notification Sent!</md-dialog-title>
      <md-dialog-content />
      <md-dialog-actions>
        <md-button class="green-5 color" @click="notifcationSentModalOpen = false">OK</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import NotificationTargets from './NotificationTargets';
import TargetList from './TargetList.vue';

const notificationColors = [
  'red',
  '#ff8000',
  '#ffb300',
  '#018786',
  '#50ccd5',
  '#5450d5',
  '#b329e3',
  '#d550c3',
]

export default {
  name: 'create-notifications',
  components: {
    NotificationTargets,
    TargetList,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    sending: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Object,
      default: null,
    },
    cases: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      state: {
        notification: {
          type: 'INFO',
          title: '',
          message: '',
          color: 'red',
          targets: [],
          actions: [],
        },
        url: '',
        caseId: null,
      },
      notificationColors,
      notificationTargetsKey: 0,  // used to clear notification-targets component via re-render
      notifcationSentModalOpen: false,
    };
  },
  computed: {
    sendEnabled() {
      return this.state.notification.title.length > 0 &&
             this.state.notification.message.length > 0 &&
             this.state.notification.targets.length > 0;
    }
  },
  watch: {
    sending(newVal, oldVal) {
      if (oldVal && !newVal && !this.error) {
        this.resetNotification();
        this.notifcationSentModalOpen = true;
      }
    },
  },
  methods: {
    addTargets(targets) {
      targets.forEach(newTarget => {        
        const exists = this.state.notification.targets.find(existing => 
          this.targetsEqual(newTarget, existing)
        );
        if (!exists) {
          this.state.notification.targets.push(newTarget);
        }
      });
    },
    setUrl(url) {
      this.state.url = url;
      if (url == '') {
        return;
      }
      this.state.caseId = null;
      this.state.notification.actions = [{
        label: 'Go to',
        type: 'URL',
        metadata: { url },
      }];
    },
    setCaseId(caseId) {
      this.state.url = '';
      this.state.caseId = caseId;
      this.state.notification.actions = [{
        label: 'Go to',
        type: 'CASE_LINK',
        metadata: { caseId },
      }];
    },
    sendNotification() {
      this.state.notification.date = new Date();
      this.$emit('send', this.state.notification);
    },
    resetNotification() {
      this.state.notification = {
        type: 'INFO',
        title: '',
        message: '',
        color: 'red',
        targets: [],
        actions: [],
      };
      this.state.url = '';
      this.state.caseId = null;
      this.notificationTargetsKey += 1; // reset notification-targets component via re-render
    },
    deleteTarget(target) {
      this.state.notification.targets = this.state.notification.targets.filter(t => {
        return !this.targetsEqual(t, target);
      });
    },
    targetsEqual(t1, t2) {
      return t1.principalId == t2.principalId && 
        t1.principalType == t2.principalType;
    },
  },
};
</script>

<style scoped>
.error {
  color: red;
}
.container {
  display: flex;
}
.left-column .md-textarea {
  resize: none !important;
}
.right-column {
  display: flex;
  flex-direction: column;
}

.target-list {
  margin-top: 10px;
  margin-bottom: 10px;
}

.actions {
  display: flex;
  justify-content: flex-end;
}

label {
  font-size: 16px;
}

.or {
  margin: 28px 10px 0 10px;
}

.notification-color-select .md-radio {
  margin: 6px 6px 6px 0;
  border-radius: 50%;
}
.notification-color-select .md-radio >>> .md-radio-container {
  border: none;
  transition-duration: .1s;
}
.notification-color-select .md-radio.md-checked >>> .md-radio-container {
  border: solid 4px rgba(0, 0, 0, 0.5);;
  box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.5);
}
.notification-color-select .md-radio.md-checked >>> .md-radio-container:after,
.notification-color-select .md-radio >>> .md-radio-container .md-ripple,
.notification-color-select .md-radio >>> .md-radio-container:before {
  display: none;
}
</style>
